<template>
  <div class="widget">
    <div class="widget-heading">
      <div class="d-flex align-items-center document__heading">
        <FontAwesomeIcon :icon="'fa-light fa-' + icon" />
        <div class="ms-3">
          <h3 class="textStyle">{{ title }}</h3>
          <span class="document__baseline">{{ baseline }}</span>
        </div>
      </div>
    </div>
    <div class="widget-content">
      <ButtonDownloadFileComponent
        :title="$t('downloadPdfModel')"
        buttonType="button"
        className="bg-light-primary w-100"
        @download="download"
      />
      <div class="mt-2">
        <FileTypeComponent v-if="fileModels && fileModels.vars" :model="fileModels" @update="updateDocument" />
      </div>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import ButtonDownloadFileComponent from "@/components/utils/ButtonDownloadFileComponent.vue";
import FileTypeComponent from "@/components/form/FileTypeComponent.vue";

export default {
  name: "RegistrationDocumentBlockComponent",
  components: { FileTypeComponent, ButtonDownloadFileComponent, FontAwesomeIcon },
  props: {
    title: {
      type: String,
      required: true,
    },
    baseline: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    fileModels: {
      type: Object,
      required: true,
    },
  },
  emits: ["updateDocument", "download"],
  data() {
    return {};
  },
  methods: {
    updateDocument() {
      this.$emit("updateDocument");
    },
    download() {
      this.$emit("download");
    },
  },
};
</script>

<style lang="scss" scoped>
.document {
  &__heading {
    svg {
      width: 25px;
      height: 25px;
    }
  }

  &__baseline {
    color: $light-grey;
  }
}
</style>
